module.exports = __webpack_public_path__ + "images/ford_smallc8cb1c77e7f5cdde61be985837901513.png";